export default {
  state: {
    menu: null,
    currentItemEdit: null
  },
  mutations: {
    setCurrentItemEdit (state, currentItemEdit) {
      state.currentItemEdit = currentItemEdit
    },
    setMenu (state, menu) {
      state.menu = menu
    }
  },
  actions: {
    setMenu ({ commit }, menu) {
      commit('setMenu', menu)
    },
    updateCurrentItemEdit ({ commit }, data) {
      commit('setCurrentItemEdit', data)
    }
  },
  getters: {
    getCurrentItemEdit: (state) => state.currentItemEdit,
    getMenu: state => state.menu
  }
}
